<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>

          <a-col :span="24">
            <a-form-item label="业务日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择业务日期" v-decorator="['businessDate', validatorRules.businessDate]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-item label="项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['project', validatorRules.project]" :trigger-change="true" dictCode="bms_project" placeholder="请选择项目"/>
            </a-form-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['insurer', validatorRules.insurer]"
                :trigger-change="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="险种名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuranceName', validatorRules.insuranceName]" placeholder="请输入险种全称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="险种类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag ref="insuranceType" type="list" v-decorator="['insuranceType', validatorRules.insuranceType]" :trigger-change="true" dictCode="bms_insurance_type" placeholder="请输入险种全称" disabled/>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['cleanPremium', validatorRules.cleanPremium]" :formatter="moneyFormatter" :parser="moneyParser" placeholder="请输入去税保费" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>

          <!--<a-col :span="24">
            <a-form-item label="佣金(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['brokerage', {}]" :formatter="moneyFormatter" placeholder="请输入佣金" style="width: 100%" ></a-input-number>
            </a-form-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-item label="开票单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                v-decorator="['invoiceUnit', validatorRules.invoiceUnit]"
                placeholder="请选择开票单位"
                :getPopupContainer = "(target) => target.parentNode">
                <a-select-option v-for="(item) in invoiceUnits" :value="item.orgCode">{{item.departName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction, postAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue, moneyFormatter, moneyParser, toDecimal } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JTreeSelect from "@/components/jeecg/JTreeSelect"
  import JUpload from '@/components/jeecg/JUpload'

  export default {
    name: 'BizEnterprisePensionForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
      JSearchSelectTag,
      JTreeSelect,
      JUpload
    },
    props: {
      //表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data: function() {
      return {
        form: this.$form.createForm(this),
        model: {},
        invoiceUnits:[],
        isEdit: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          businessDate: {
            rules: [
              { required: true, message: '请选择业务日期!' }
            ]
          },
/*          project: {
            rules: [
              { required: true, message: '请选择项目!' },
            ]
          },*/
          insurer: {
            rules: [
              { required: true, message: '请选择保险公司!' },
              { validator: this.checkInsurerAgreement}
            ]
          },
          insuranceType: {
            rules: [
              { required: true, message: '请选择险种类型!' }
            ]
          },
          insuranceName: {
            rules: [
              { required: true, message: '请输入险种名称!' },
              { max: 50, message: '险种名称长度不能超过50' },
              { whitespace: true, message:'不能为空格'},
              { validator: this.checkInsuranceType}
            ]
          },
          cleanPremium: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入保费!' }
            ]
          },

          /*brokerage: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入佣金!' }
            ]
          },*/
          invoiceUnit:{
            rules: [
              { required: true, trigger: 'blur', message: '请选择开票单位!' }
            ]
          },
        },
        url: {
          add: '/biz/enterprisePension/add',
          edit: '/biz/enterprisePension/edit',
          queryById: '/biz/enterprisePension/queryById',
          checkInsurerAgreement: '/biz/bizAgreementinfo/judgeAgreementByCode',
          checkInsuranceType:'/biz/insuranceWithType/getInsuranceTypeByName',
          getInvoiceUnit: "/sys/sysDepart/getInvoiceUnitByUser",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      showFlowSubmitButton(){
        return false
      }
    },
    created () {
      this.initInvoiceUnit();
    },
    methods: {
      moneyFormatter,
      moneyParser,
      initInvoiceUnit(){
        this.invoiceUnits = []
        //根据当前登录用户获取能选择的开票单位
        getAction(this.url.getInvoiceUnit, {}).then((res) =>{
          if(res.success){
            this.invoiceUnits = res.result;
          }
        })
      },
      add () {
        this.edit({});
      },

      edit (record) {
        if(record.id != null){
          this.isEdit = true;
        } else {
          this.isEdit = false;
        }
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'businessDate','insurer','insuranceType','insuranceName',
           'cleanPremium','invoiceUnit')) //'brokerage',
        })
      },

      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            formData.businessDate = formData.businessDate + " 10:00:00";
            //去除输入的两边空格
            this.trimFormData(formData);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      trimFormData(formData){
        formData.insuranceName = formData.insuranceName ? formData.insuranceName.trim(): ''
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'businessDate','insurer','insuranceType','insuranceName',
          'cleanPremium','invoiceUnit'))
      },

      // 检查是否与保司签订协议, value:保司code
      checkInsurerAgreement(rule,value,callback){
        if(!value){ // 没有值
          callback()
        }
        getAction(this.url.checkInsurerAgreement,{companyCode: value}).then( (res) => {
          if(res.success){
            callback()
          } else {
            callback(res.message)
          }
        })
      },

      // 检查险种名称是否有对应的险种类型
      checkInsuranceType(rule,value,callback){
        if(!value){ // 没有值
          callback()
        }
        this.form.setFieldsValue({insuranceType: null}) // 先清空
        postAction(this.url.checkInsuranceType,{insuranceName: value}).then( (res) => {
          if(res.success){
            if(res.result){
              let insuranceTypeId = res.result
              this.form.setFieldsValue({insuranceType: insuranceTypeId});
              callback()
            } else {
              callback("此险种名称没有配置险种类型")
            }
          } else {
            callback("此险种名称没有配置险种类型")
          }
        })
      },
    }
  }
</script>